(function () {
    function ready(fn) {
        if (document.readyState !== 'loading')
            fn();
        else document.addEventListener('DOMContentLoaded', fn);
    }
    ready(function () {
        const btns = document.querySelectorAll('.share-btn-water');
        btns.forEach(btn => {
            btn.addEventListener('click', function () {
                try {
                    const title = document.querySelector('meta[property="og:title"]')?.getAttribute('content') || document.title;
                    const text = document.querySelector('meta[property="og:description"]')?.getAttribute('content') || '';
                    const url = document.querySelector('meta[property="og:url"]')?.getAttribute('content') || location.href;
                    if (navigator.share) {
                        navigator.share({ title, text, url }).catch(() => { });
                    } else {
                        // Fallback: copy link
                        navigator.clipboard?.writeText(url).then(() => {
                            try {
                                if (window.toasts && typeof window.toasts.show === 'function') {
                                    window.toasts.show('Link copied', 'URL copied to clipboard.', 'success');
                                } else {
                                    console.log('[share] Link copied to clipboard:', url);
                                }
                            } catch (e) { console.log('[share] Link copied to clipboard'); }
                        }).catch(() => {
                            try { console && console.warn && console.warn('Share failed'); } catch (e) { }
                        });
                    }
                }
                catch (e) {
                    console && console.warn && console.warn('Share failed', e);
                }
            });
        });
    });
})();

(function () {
    function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
    ready(function () {
        document.querySelectorAll('.share-btn-water').forEach(btn => {
            btn.addEventListener('click', () => {
                const t = btn.getAttribute('data-share-title') || document.title;
                const x = btn.getAttribute('data-share-text') || '';
                const s = btn.getAttribute('data-share-slug') || '';
                window.shareContent(t, x, s, 'slug');
            });
        });
    });
})();
